import { createContext, useContext, useState } from "react";

const ReachbackContext = createContext();

export const ReachbackProvider = ({ children }) => {
  // const [submittedErrors, setSubmittedErrors] = useState(null);
  const [submittedErrorsT, setSubmittedErrorsT] = useState(false);
  const [submittedErrorsB, setSubmittedErrorsB] = useState(false);
  const [reachbackReason, setReachbackReason] = useState({});

  const updateSubmittedErrorsT = (errors) => {
    // setSubmittedErrors(errors);
    setSubmittedErrorsT(errors);
  };

  const updateSubmittedErrorsB = (errors) => {
    // setSubmittedErrors(errors);
    setSubmittedErrorsB(errors);
  };

  const addReachbackReason = (reason) => {
    setReachbackReason({ ...reachbackReason, ...reason });
  };

  const removeReachbackReason = (key) => {
    const updatedReason = { ...reachbackReason };
    delete updatedReason[key];
    setReachbackReason(updatedReason);
  };

  return (
    <ReachbackContext.Provider
      value={{
        // submittedErrors,
        submittedErrorsT,
        submittedErrorsB,
        updateSubmittedErrorsT,
        updateSubmittedErrorsB,
        reachbackReason,
        addReachbackReason,
        removeReachbackReason,
      }}
    >
      {children}
    </ReachbackContext.Provider>
  );
};

export const useReachbackContext = () => {
  return useContext(ReachbackContext);
};
